import { render, staticRenderFns } from "./AddPlace.modal.vue?vue&type=template&id=029a1254"
import script from "./AddPlace.modal.vue?vue&type=script&lang=js"
export * from "./AddPlace.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports